class RatingHelper {
  static toReal(rating) {
    return rating / 2;
  }

  static toRounded(rating, nrOfDecimals = 1) {
    return parseFloat(RatingHelper.toReal(rating).toFixed(nrOfDecimals));
  }

  static toHalf(rating) {
    return Math.ceil(RatingHelper.toRounded(rating) * 2) / 2;
  }

  static toWhole(rating) {
    return Math.round(RatingHelper.toHalf(rating));
  }

  static convert(rating, nrOfDecimals = 1) {
    return {
      real: RatingHelper.toReal(rating),
      rounded: RatingHelper.toRounded(rating, nrOfDecimals),
      half: RatingHelper.toHalf(rating),
      whole: RatingHelper.toWhole(rating),
    };
  }
}

export default RatingHelper;
